import { ShippingMethodTypes } from '@monofront/types';
import { ISelectDaySlotEvent, ISelectShippingMethodContext } from './types';

export const isCartMissing = (context: ISelectShippingMethodContext) =>
  context.checkoutCartId == null;

export const isDaySlotTimeSlotSelected = (
  _: ISelectShippingMethodContext,
  event: ISelectDaySlotEvent,
) =>
  Boolean(event.timeSlotSelected.timeSlot && event.timeSlotSelected.timeSlotId);

export const isMethodSelected = (context: ISelectShippingMethodContext) =>
  Boolean(context.shippingMethod.shipmentMethodCode);

export const isHomeMethodSelected = (context: ISelectShippingMethodContext) =>
  context.methodType === ShippingMethodTypes.HOME &&
  context.methodsList.some(({ code }) => code === context.methodSelectedCode);

export const isClickAndCollectMethodSelected = (
  context: ISelectShippingMethodContext,
) =>
  context.methodType === ShippingMethodTypes.CLICK_AND_COLLECT &&
  context.methodsList.some(({ code }) => code === context.methodSelectedCode);

export const isCourierMethodSelected = (
  context: ISelectShippingMethodContext,
) =>
  context.methodType === ShippingMethodTypes.COURIER &&
  context.methodsList.some(({ code }) => code === context.methodSelectedCode);

export const isPickupPointSelected = (context: ISelectShippingMethodContext) =>
  context.methodType === ShippingMethodTypes.PICKUP &&
  Boolean(context.shippingMethod.pointId) &&
  context.methodsList.some(({ type }) => type === ShippingMethodTypes.PICKUP);

export const isPickupMethodSelected = (context: ISelectShippingMethodContext) =>
  context.methodType === ShippingMethodTypes.PICKUP &&
  !context.shippingMethod.pointId &&
  context.methodsList.some(({ code }) => code === context.methodSelectedCode);

export const isCourierFirstMethod = (context: ISelectShippingMethodContext) =>
  context.isUnpreselectShippingMethodABTestEnabled
    ? false
    : context.methodsList?.[0]?.type === ShippingMethodTypes.COURIER;

export const isPickupFirstMethod = (context: ISelectShippingMethodContext) =>
  context.isUnpreselectShippingMethodABTestEnabled
    ? false
    : context.methodsList?.[0]?.type === ShippingMethodTypes.PICKUP;

export const isHomeFirstMethod = (context: ISelectShippingMethodContext) =>
  context.isUnpreselectShippingMethodABTestEnabled
    ? false
    : context.methodsList?.[0]?.type === ShippingMethodTypes.HOME;

export const isClickAndCollectFirstMethod = (
  context: ISelectShippingMethodContext,
) =>
  context.isUnpreselectShippingMethodABTestEnabled
    ? false
    : context.methodsList?.[0]?.type === ShippingMethodTypes.CLICK_AND_COLLECT;

export const isNoShipment = (context: ISelectShippingMethodContext) =>
  context.noShipment;
export const fromEvent = (_, event) => Boolean(event.type);

export const isClearShippingMethodSelectionForced = (_, event) =>
  event.resetShippingMethodSelection;
